module.exports = __webpack_public_path__ + "static/media/Warning.8ea30991.png";